import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Reveal from '../components/Reveal';
import Seo from '../components/Seo';
import ContactForm from '../components/ContactForm';
import { COMPANY } from '../data/mock';

const Contact = () => {
  const info = [
    { icon: Phone, label: 'Call Anytime', value: COMPANY.phone, href: COMPANY.phoneHref },
    { icon: Mail, label: 'Email Us', value: COMPANY.email, href: `mailto:${COMPANY.email}` },
    { icon: MapPin, label: 'Mailing Address', value: COMPANY.address },
    { icon: Clock, label: 'Online Booking', value: 'Request a quote 24/7' },
  ];
  return (
    <div>
      <Seo
        path="/contact"
        title="Contact & Booking"
        description="Book a mold inspection or indoor air quality test in Southern Ontario. Call (226) 972-6440 or request a free quote — we respond within one business day."
      />
      <section className="brand-gradient relative overflow-hidden">
        <div className="absolute -top-20 -left-20 h-72 w-72 rounded-full bg-[#c7e79b]/40 blur-3xl" />
        <div className="relative max-w-4xl mx-auto px-5 lg:px-8 py-16 lg:py-20 text-center">
          <Reveal>
            <span className="text-brand font-semibold text-sm uppercase tracking-wider">Contact &amp; Booking</span>
            <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold text-[#13251b] leading-tight">Let’s get your inspection booked</h1>
            <p className="mt-5 text-lg text-[#44564b] max-w-2xl mx-auto">Have questions, want a quote, or ready to schedule? We respond to every request within one business day.</p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-12">
          <Reveal className="lg:col-span-2 space-y-5">
            <h2 className="text-2xl font-bold text-[#13251b]">Get in touch</h2>
            <p className="text-[#5b6a60]">Reach us by phone, email, or the form — whichever suits you best.</p>
            <div className="space-y-4 mt-6">
              {info.map((item) => {
                const Icon = item.icon;
                const content = (
                  <div className="flex items-start gap-4 bg-[#fafcf7] rounded-2xl p-5 border border-[#eef2e8] hover:border-brand transition-colors">
                    <div className="h-11 w-11 shrink-0 rounded-xl bg-[#eaf4dd] flex items-center justify-center">
                      <Icon className="h-5 w-5 text-brand" />
                    </div>
                    <div>
                      <div className="text-sm text-[#5b6a60]">{item.label}</div>
                      <div className="font-semibold text-[#13251b] break-words">{item.value}</div>
                    </div>
                  </div>
                );
                return item.href ? (
                  <a key={item.label} href={item.href} className="block">{content}</a>
                ) : (
                  <div key={item.label}>{content}</div>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-3">
            <div className="bg-white rounded-[1.5rem] p-7 lg:p-8 shadow-[0_20px_50px_-24px_rgba(20,50,25,0.25)] border border-[#eef2e8]">
              <h3 className="text-2xl font-bold text-[#13251b]">Request a free quote</h3>
              <p className="mt-1 text-sm text-[#5b6a60] mb-6">Fill out the form and we’ll be in touch shortly.</p>
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Contact;
